module.exports = __webpack_public_path__ + "static/media/unibest-solution-img1.7759bcbb.png";